const __WEBPACK_NAMESPACE_OBJECT__ = require("element-ui/lib/checkbox");